"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var React = require("react");
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        return _super.call(this, props) || this;
    }
    Form.prototype.render = function () {
        var _this = this;
        return (React.createElement("form", { onKeyDown: function (e) {
                /**
                 * Note: Pressing enter in some input in a browser forms
                 *  triggers onClick on the first child button
                 *
                 * So, prevent `enter` from triggering `onClick` on any buttons
                 *  and instead trigger onSubmit
                 */
                if (e.key === 'Enter') {
                    e.preventDefault();
                    _this.props.onSubmit();
                }
            }, onSubmit: function (e) {
                /**
                 * Prevent submit from reloading the page
                 */
                e.preventDefault();
                e.stopPropagation();
                _this.props.onSubmit();
            } },
            React.createElement("div", { className: "error" },
                " ",
                this.props.error,
                " "),
            this.props.children));
    };
    return Form;
}(React.Component));
exports.Form = Form;
